<div class="backgroundImagePanel"  [@enter]="animationStateIn" [@leave]="animationStateOut"
    (@leave.done)="animOutDone()" (@enter.done)="animInDone()">
    <img  id="backgroundImage" class='backgroundImageHide' (load)="chargeCanvas()" *ngIf="currentImage" [src]="currentImage" alt="">
    <canvas id="backgroundCanvas"  *ngIf="currentImage" class='backgroundCanvas'></canvas>
    <div class="defaultImage backgroundImage" *ngIf="!currentImage">
        <img [src]="defaultImage" alt="">
    </div>
    <div class="gradient-overlay"></div>
</div>